import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectUniteIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M22 8.25H15.75V2C15.75 1.5859 15.4141 1.25 15 1.25H2C1.5859 1.25 1.25 1.5859 1.25 2V15C1.25 15.4141 1.5859 15.75 2 15.75H8.25V22C8.25 22.4141 8.5859 22.75 9 22.75H22C22.4141 22.75 22.75 22.4141 22.75 22V9C22.75 8.5859 22.4141 8.25 22 8.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectUniteIcon.displayName = 'SelectUniteIcon';
